import React, { useEffect, useRef, useState } from "react";
import { sosContent, AC_FORM_ID, AC_OR, AC_FIELDS, WHATSAPP_URL } from "../content";
import { dispararGenerateLead } from "./base";
import { registrarInscricao } from "../inscricao";

/* Formulário de inscrição. Mesmo caminho do Craques do Enem: JSONP para o
 * ActiveCampaign (form 382, sem script externo), callbacks no window.
 * Depois do envio: `generate_lead` no dataLayer e a pessoa vai direto para o
 * grupo do WhatsApp. A tela de sucesso é rede de segurança: aparece em 2,5 s
 * se a navegação não acontecer, com o botão do grupo. */

const AC_PROC_URL = "https://aprovatotal.activehosted.com/proc.php";
const EMAIL_RE = /^[+_a-z0-9-'&=]+(\.[+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;

function formatPhone(raw) {
  const d = raw.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export default function Form() {
  const c = sosContent.form;
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [zap, setZap] = useState("");
  const [objetivo, setObjetivo] = useState("");
  const [erros, setErros] = useState({});
  const [estado, setEstado] = useState("idle");
  const utms = useRef({});

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    utms.current = {
      utmcampaign: p.get("utm_campaign") || p.get("utmcampaign") || "",
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_content: p.get("utm_content") || "",
      utm_term: p.get("utm_term") || "",
    };
    const e = p.get("email");
    if (e) setEmail(e);
  }, []);

  function validar() {
    const n = {};
    if (!nome.trim()) n.nome = c.erros.nome;
    if (!EMAIL_RE.test(email.trim())) n.email = c.erros.email;
    if (zap.replace(/\D/g, "").length < 10) n.zap = c.erros.whatsapp;
    if (!objetivo) n.objetivo = c.erros.objetivo;
    setErros(n);
    return Object.keys(n).length === 0;
  }

  function sucesso() {
    if (!WHATSAPP_URL) {
      dispararGenerateLead("sos-aprova", { campanha: "sos-aprova", objetivo });
      setEstado("ok");
      return;
    }
    dispararGenerateLead("sos-aprova", { campanha: "sos-aprova", objetivo }, () => {
      window.location.href = WHATSAPP_URL;
      window.setTimeout(() => setEstado("ok"), 2500);
    });
  }

  async function onSubmit(ev) {
    ev.preventDefault();
    if (estado === "enviando" || !validar()) return;
    setEstado("enviando");
    await registrarInscricao({ nome, email, whatsapp: zap, objetivo });
    if (!AC_FORM_ID) {
      sucesso();
      return;
    }
    const params = new URLSearchParams({ u: AC_FORM_ID, f: AC_FORM_ID, s: "", c: "0", m: "0", act: "sub", v: "2", or: AC_OR });
    params.set("fullname", nome.trim());
    params.set("email", email.trim());
    // O embed do AC manda "+55 DDDNUMERO" (código separado por espaço).
    params.set("phone", `+55 ${zap.replace(/\D/g, "")}`);
    params.set(`field[${AC_FIELDS.interesses}]`, objetivo);
    ["utm_term", "utmcampaign", "utm_source", "utm_medium", "utm_content"].forEach((k) => {
      params.set(`field[${AC_FIELDS[k]}]`, utms.current[k] || "");
    });
    window._show_thank_you = () => sucesso();
    window._show_pc_confirmation = () => sucesso();
    window._show_error = (_id, message) => {
      setEstado("idle");
      setErros({ envio: message || c.erros.envio });
    };
    window._load_script = () => {};
    const s = document.createElement("script");
    s.src = `${AC_PROC_URL}?${params.toString()}&jsonp=true`;
    s.async = true;
    s.onerror = () => {
      setEstado("idle");
      setErros({ envio: c.erros.envio });
    };
    document.head.appendChild(s);
  }

  if (estado === "ok") {
    return (
      <div className="sos-ok" role="status">
        <b>{c.sucesso.titulo}</b>
        <p>{c.sucesso.texto}</p>
        {WHATSAPP_URL && (
          <a href={WHATSAPP_URL} rel="noopener noreferrer" className="sos-btn">
            {c.sucesso.cta}
          </a>
        )}
      </div>
    );
  }

  return (
    <form className="sos-form" onSubmit={onSubmit} noValidate>
      <span className="sos-form-titulo">{c.titulo}</span>

      <label className="sos-label">
        {c.campos.nome.label}
        <input className="sos-input" name="nome" autoComplete="name" placeholder={c.campos.nome.placeholder} value={nome} onChange={(e) => setNome(e.target.value)} aria-invalid={!!erros.nome} />
        {erros.nome && <span className="sos-erro">{erros.nome}</span>}
      </label>
      <label className="sos-label">
        {c.campos.email.label}
        <input className="sos-input" name="email" type="email" autoComplete="email" inputMode="email" placeholder={c.campos.email.placeholder} value={email} onChange={(e) => setEmail(e.target.value)} aria-invalid={!!erros.email} />
        {erros.email && <span className="sos-erro">{erros.email}</span>}
      </label>
      <label className="sos-label">
        {c.campos.whatsapp.label}
        <input className="sos-input" name="whatsapp" type="tel" autoComplete="tel" inputMode="tel" placeholder={c.campos.whatsapp.placeholder} value={zap} onChange={(e) => setZap(formatPhone(e.target.value))} aria-invalid={!!erros.zap} />
        {erros.zap && <span className="sos-erro">{erros.zap}</span>}
      </label>

      <label className="sos-label">
        {c.campos.objetivo.label}
        <span className="sos-select-wrap">
          <select className="sos-input sos-select" name="objetivo" value={objetivo} data-vazio={objetivo === ""} onChange={(e) => setObjetivo(e.target.value)} aria-invalid={!!erros.objetivo}>
            <option value="" disabled>
              {c.campos.objetivo.placeholder}
            </option>
            {c.campos.objetivo.opcoes.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
        </span>
        {erros.objetivo && <span className="sos-erro">{erros.objetivo}</span>}
      </label>

      <button type="submit" className="sos-btn" disabled={estado === "enviando"}>
        {c.cta}&nbsp;→
      </button>
      {erros.envio && (
        <span className="sos-erro" role="alert">
          {erros.envio}
        </span>
      )}
      <p className="sos-form-rodape">
        <strong>{c.rodape}</strong>
      </p>
    </form>
  );
}
